import script from "./RevenueChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./RevenueChart.vue?vue&type=script&setup=true&lang=ts"

import "./RevenueChart.vue?vue&type=style&index=0&id=9997577c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9997577c"]])

export default __exports__